import { createContext } from 'react';
import { GroupLine, GroupState, GroupStatus } from '../../services/api/group';
import { Item } from '../site/site-context';
import { LineChanges, StoredGroup } from '../../services/groupOrder';

// Why a group order is over, for whoever was in it
export type GroupEnd = 'cancelled' | 'placed';

export type GroupContextData = {
    // in a group order that is still going
    active: boolean;
    isLead: boolean;
    // the lead is choosing a time or checking out, so nothing can be added
    locked: boolean;

    session: StoredGroup | null;
    state: GroupState | null;
    status: GroupStatus | null;
    // the lead sees everybody's, guests their own
    lines: GroupLine[];
    // changes whenever the lines do
    revision: string | undefined;
    host: string | null;
    name: string | null;
    guestCount: number;
    ended: GroupEnd | null;

    // who is hosting the group order in a link, before joining it
    preview: GroupState | null;
    previewFailed: boolean;
    fetchPreview: (token: string) => void;

    // (what's in the basket already comes along)
    start: (siteUid: string, name: string, items?: Item[]) => Promise<void>;
    join: (token: string, name: string) => Promise<void>;
    leave: () => Promise<void>;
    cancel: () => Promise<void>;
    setLocked: (locked: boolean) => Promise<void>;
    sendChanges: (changes: LineChanges) => void;
    // forget the group order on this device (when it's over, or left)
    clear: () => void;
};

export const GroupContext = createContext<GroupContextData>({
    active: false,
    isLead: false,
    locked: false,

    session: null,
    state: null,
    status: null,
    lines: [],
    revision: undefined,
    host: null,
    name: null,
    guestCount: 0,
    ended: null,

    preview: null,
    previewFailed: false,
    fetchPreview: () => {},

    start: () => Promise.resolve(),
    join: () => Promise.resolve(),
    leave: () => Promise.resolve(),
    cancel: () => Promise.resolve(),
    setLocked: () => Promise.resolve(),
    sendChanges: () => {},
    clear: () => {},
});
